import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';

export function* getBarcodeCategories() {
  try {
    const params = {
      query: {
        limit: 10000,
        page: 1,
      },
    };

    const { data } = yield call(request, API.BARCODE_CATEGORIES, 'GET', params);

    yield put(actions.getBarcodeCategoriesSuccess(data));
  } catch (e) {
    yield put(actions.getBarcodeCategoriessError(e));
  }
}

export function* getBarcodeCategoriesWatcher() {
  yield takeEvery(constants.GET_BARCODE_CATEGORIES, getBarcodeCategories);
}
